import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { IMusicProductPhysicalForm } from 'services/music-product-physical/types/form';
import { useGetSalesChannelsLightList } from 'services/salesChannel';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const MusicProductPhysicalExternal = () => {
  const {
    values,
    status,
    setFieldValue,
    errors,
  }: IFormikContextType<IMusicProductPhysicalForm> =
    useFormikContext<IMusicProductPhysicalForm>();

  const { t } = useTranslation();

  const salesChannels = useGetSalesChannelsLightList();

  const salesChannelOptions =
    salesChannels.data
      ?.map(s => ({ label: s.name, value: s.name }))
      .filter(
        option =>
          !values.externalIds.find(external => external.type === option.label)
      ) ?? [];

  const isLatestTypeSelected = !!values.externalIds.length
    ? !!values.externalIds[values.externalIds.length - 1]?.type.length
    : true;

  return (
    <Table
      id={'MusicProductPhysicalExternal'}
      size='compact'
      data={{
        nodes: values.externalIds.map((external, index) => ({
          externalId: external.id,
          externalType: external.type,
          id: index,
          link: external.link,
        })),
      }}
      columns={[
        {
          label: t('input.label.externalIdType'),
          renderCell: ({ externalType, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={externalType} />
              ) : (
                <FormInput.Select
                  name={`externalIds[${id}].type`}
                  label={t('input.label.externalIdType')}
                  className='max-w-96'
                  options={salesChannelOptions}
                  isCreatable
                />
              )}
            </TableItem>
          ),
          resize: true,
        },
        {
          label: 'ID',
          renderCell: ({ externalId, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={externalId} />
              ) : (
                <FormInput.Text
                  name={`externalIds[${id}].id`}
                  label={t(`input.label.externalId`)}
                  className='max-w-96'
                />
              )}
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ id, link }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                !!link?.length && (
                  <Button
                    isClear
                    onlyIcon
                    onClick={() => window.open(link, '_blank')}>
                    <Button.Icon
                      icon={<PiNavigationArrow transform='scale(-1,1)' />}
                    />
                  </Button>
                )
              ) : (
                <Button
                  isClear
                  onlyIcon
                  variant={BUTTON_VARIANT.remove}
                  onClick={() =>
                    setFieldValue(
                      'externalIds',
                      values.externalIds.filter(
                        (external, index) => id !== index
                      )
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={!isLatestTypeSelected}
                    onClick={() =>
                      setFieldValue(
                        `externalIds[${values.externalIds.length}]`,
                        {
                          id: '',
                          type: '',
                        }
                      )
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
    />
  );
};

export default MusicProductPhysicalExternal;
